module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-lock-closed-17c6cfda1d8f26194c1a00db0352ec51.png";